import React, { createContext, useContext, useEffect, useState } from "react";
import * as Sentry from "@sentry/react";

export const UserDetailsContext = createContext<{
  studentId: string;
  id: string;
  setId: (id: string) => void;
  bearer: string;
  setBearer: (id: string) => void;
  data: any;
  setData: (data: any) => void;
} | null>(null);

export function ProvideUserDetails({
  children,
}: {
  children: React.ReactNode;
}) {
  const provider = useProvideUserDetails();
  return (
    <UserDetailsContext.Provider value={provider}>
      {children}
    </UserDetailsContext.Provider>
  );
}

export const useUserDetails = () => {
  const context = useContext(UserDetailsContext);
  if (context === null) {
    throw Error("UserDetails context not provided");
  }
  return context;
};

const useProvideUserDetails = () => {
  const [id, setId] = useState("");
  const [bearer, setBearer] = useState("");
  const [data, setData] = useState<any | null>(null);

  // Teachers have an id, students their data (sometimes as a JSON string)
  useEffect(() => {
    if (id) {
      Sentry.setUser({ id: `teacher-${id}` });
      return;
    }
    try {
      const student = typeof data === "string" ? JSON.parse(data) : data;
      Sentry.setUser(student?.id ? { id: `student-${student.id}` } : null);
    } catch {
      Sentry.setUser(null);
    }
  }, [id, data]);

  return {
    id,
    setId,
    bearer,
    setBearer,
    data,
    setData,
    studentId: data?.id ?? "",
  };
};
